/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Auto_FormatInputs */

const en_apply_auto_format = /** @type {(inputs: Apply_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply auto format`)
};

const fr_apply_auto_format = /** @type {(inputs: Apply_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer l’auto-formatage`)
};

const de_apply_auto_format = /** @type {(inputs: Apply_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Formatierung anwenden`)
};

const it_apply_auto_format = /** @type {(inputs: Apply_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica formattazione automatica`)
};

const ru_apply_auto_format = /** @type {(inputs: Apply_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить автоформатирование`)
};

const es_apply_auto_format = /** @type {(inputs: Apply_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar formato automático`)
};

const zh_cn2_apply_auto_format = /** @type {(inputs: Apply_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用自动格式`)
};

const ja_apply_auto_format = /** @type {(inputs: Apply_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動フォーマットを適用する`)
};

const hi_apply_auto_format = /** @type {(inputs: Apply_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो फॉर्मेट लागू करें`)
};

const pt_pt2_apply_auto_format = /** @type {(inputs: Apply_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar formatação automática`)
};

/**
* | output |
* | --- |
* | "Apply auto format" |
*
* @param {Apply_Auto_FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_auto_format = /** @type {((inputs?: Apply_Auto_FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Auto_FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_auto_format(inputs)
	if (locale === "de") return de_apply_auto_format(inputs)
	if (locale === "it") return it_apply_auto_format(inputs)
	if (locale === "ru") return ru_apply_auto_format(inputs)
	if (locale === "es") return es_apply_auto_format(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_auto_format(inputs)
	if (locale === "ja") return ja_apply_auto_format(inputs)
	if (locale === "hi") return hi_apply_auto_format(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_auto_format(inputs)
	return en_apply_auto_format(inputs)
});